import React, { useState, useEffect } from "react";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { styles } from "../styles/style";
import PatternLock from "react-pattern-lock";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaSearch, FaPlus, FaUser, FaShieldAlt, FaSave, FaUserShield } from "react-icons/fa";

import {
  useCreateSubadminMutation,
  useGetUniqueIdQuery,
} from "../redux/features/user/userApi";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import PermissionsForm from "../Components/Kyc/PermissionsForm";

const initialPermissions = [
  {
    module: "user_details",
    module_name: "User Details",
    read: false,
    write: false,
    // submodule: [
    //   {
    //     submodule: "personal_info",
    //     submodule_name: "Personal Info",
    //     read: false,
    //     write: false,
    //   },
    //   {
    //     submodule: "security",
    //     submodule_name: "Security",
    //     read: false,
    //     write: false,
    //   },
    //   {
    //     submodule: "wallet",
    //     submodule_name: "Wallet",
    //     read: false,
    //     write: false,
    //   },
    //   {
    //     submodule: "stake_history",
    //     submodule_name: "Stake History",
    //     read: false,
    //     write: false,
    //   },
    //   {
    //     submodule: "transaction_history",
    //     submodule_name: "Transaction History",
    //     read: false,
    //     write: false,
    //   },
    // ],
  },
  {
    module: "stake_history",
    module_name: "Stake History",
    read: false,
    write: false,
  },
  {
    module: "subscribe_history",
    module_name: "Subscribe History",
    read: false,
    write: false,
  },
  {
    module: "ticket_managemenet",
    module_name: "Ticket Management",
    read: false,
    write: false,
  },
  {
    module: "enquery_managemenet",
    module_name: "Enquery Management",
    read: false,
    write: false,
  },
  // {
  //   module: "upload_data",
  //   module_name: "upload data",
  //   read: false,
  //   write: false,
  // },
  // {
  //   module: "roi_history",
  //   module_name: "ROI History",
  //   read: false,
  //   write: false,
  // },
  // {
  //   module: "referal",
  //   module_name: "Referal",
  //   read: false,
  //   write: false,
  // },
  // {
  //   module: "block_management",
  //   module_name: "Block Management",
  //   read: false,
  //   write: false,
  // },
  // {
  //   module: "admin_banks",
  //   module_name: "Admin Banks",
  //   read: false,
  //   write: false,
  // },
];

const AddSubAdmin = () => {
  const [path, setPath] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [confirmPath, setConfirmPath] = useState([]);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [permissions, setPermissions] = useState(initialPermissions);
  const navigate = useNavigate();
  const [patternError, setPatternError] = useState("");
  const [confirmPatternError, setConfirmPatternError] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setMounted(true); }, []);

  const [createSubadmin, { isSuccess, isError, error, data }] = useCreateSubadminMutation();
  const { data: uniqueId, isSuccess: uniqueIdSuccess } = useGetUniqueIdQuery();

  const returnPattern = (path) => {
    if (!path || !Array.isArray(path) || path.length === 0) return "";

    let newPath = "";
    for (let x of path) {
      const num = parseInt(x);
      if (!isNaN(num)) {
        newPath += (num + 1).toString();
      }
    }
    return newPath;
  };

  useEffect(() => {
    if (isSuccess && data?.status === true) {
      toast.success(data.message);
      navigate("/subadmin");
    } else if (isSuccess && data?.status !== true) {
      toast.error(data?.message || "Failed to create subadmin");
    }
  }, [isSuccess, data, navigate]);

  const schema = Yup.object().shape({
    name: Yup.string()
      .required("Please enter a username!")
      .matches(/^[a-zA-Z]+$/, "Username can only contain letters")
      .min(3, "Username must be at least 3 characters"),
    email: Yup.string()
      .email("Invalid email!")
      .required("Please enter an email!"),
    password: Yup.string()
      .required("Please enter the password!")
      .min(6, "Password must be at least 6 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
        "Password must contain at least one uppercase letter, one lowercase letter, and one number"
      ),
    confirmPassword: Yup.string()
      .required("Please enter the password again to confirm!")
      .min(6, "Password must be at least 6 characters")
      .oneOf([Yup.ref("password"), null], "Passwords must match!"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      username: "",
      confirmPassword: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      try {
        const pattern = returnPattern(path);
        const confirmPattern = returnPattern(confirmPath);

        if (!pattern || !confirmPattern) {
          toast.error("Please set both pattern and confirm pattern");
          return;
        }

        if (pattern !== confirmPattern) {
          toast.error("Pattern and confirm pattern do not match");
          return;
        }

        const hasPermissions = permissions.some(
          (module) => module.read || module.write ||
            module.submodule?.some((sub) => sub.read || sub.write)
        );

        if (!hasPermissions) {
          toast.error("Please set at least one permission");
          return;
        }

        const myData = {
          permission: permissions,
          password: values.password,
          username: values.name,
          unique_id: uniqueId?.unique_id,
          confirmPassword: values.confirmPassword,
          email: values.email,
          pattern: pattern,
          confirm_pattern: confirmPattern,
        };

        await createSubadmin(myData);
      } catch (error) {
        toast.error("Failed to create subadmin");
      }
    },
  });

  const { values, errors, touched, handleChange, handleSubmit } = formik;

  const handlePatternFinish = () => {
    setDisabled(true);
    setPatternError("");
    setConfirmDisabled(false);
  };

  const handleConfirmPatternFinish = () => {
    const pattern = returnPattern(path);
    const confirmPattern = returnPattern(confirmPath);

    if (pattern !== confirmPattern) {
      setConfirmPatternError("Patterns do not match");
      setConfirmDisabled(false);
      setConfirmPath([]);
    } else {
      setConfirmDisabled(true);
      setConfirmPatternError("");
    }
  };

  // Real-time validation functions
  const validateUsername = (value) => {
    if (!value) {
      setUsernameError("Username is required");
      return false;
    }
    if (!/^[a-zA-Z]+$/.test(value)) {
      setUsernameError("Username can only contain letters");
      return false;
    }
    if (value.length < 3) {
      setUsernameError("Username must be at least 3 characters");
      return false;
    }
    setUsernameError("");
    return true;
  };

  const validateEmail = (value) => {
    if (!value) {
      setEmailError("Email is required");
      return false;
    }
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(value)) {
      setEmailError("Please enter a valid email address");
      return false;
    }
    setEmailError("");
    return true;
  };

  const validatePassword = (value) => {
    if (!value) {
      setPasswordError("Password is required");
      return false;
    }
    if (value.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      return false;
    }
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(value)) {
      setPasswordError("Password must contain at least one uppercase letter, one lowercase letter, and one number");
      return false;
    }
    setPasswordError("");
    return true;
  };

  const validateConfirmPassword = (value, password) => {
    if (!value) {
      setConfirmPasswordError("Please confirm your password");
      return false;
    }
    if (value !== password) {
      setConfirmPasswordError("Passwords do not match");
      return false;
    }
    setConfirmPasswordError("");
    return true;
  };

  // Custom handleChange with real-time validation
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleChange(e);

    switch (name) {
      case "name":
        validateUsername(value);
        break;
      case "email":
        validateEmail(value);
        break;
      case "password":
        validatePassword(value);
        validateConfirmPassword(values.confirmPassword, value);
        break;
      case "confirmPassword":
        validateConfirmPassword(value, values.password);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 pt-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto py-8">
          {/* Header Section */}
          <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 border border-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
                  <FaUserShield className="text-white text-xl" />
                </div>
                <div>
                  <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    Add New Subadmin
                  </h1>
                  <p className="text-gray-500 text-sm mt-1">Create a new subadmin account with permissions</p>
                </div>
              </div>
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 hover:border-gray-300 transition-all duration-300"
              >
                <FaLongArrowAltLeft className="text-gray-600" />
                <span>Back</span>
              </button>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Personal Information Card */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 mb-6">
              <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-purple-50">
                <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                  <FaUser className="text-blue-600" />
                  Personal Information
                </h2>
              </div>

              <div className="p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Left Column */}
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">User Name</label>
                      <input
                        className={`w-full px-4 py-3 rounded-xl border-2 ${usernameError ? 'border-red-500 focus:border-red-500 focus:ring-red-100' : 'border-gray-200 focus:border-blue-500 focus:ring-blue-100'} focus:ring-4 transition-all duration-200 outline-none text-gray-700 placeholder-gray-400`}
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter username"
                        onChange={handleInputChange}
                        value={values.name}
                        onBlur={() => validateUsername(values.name)}
                      />
                      {usernameError && (
                        <span className="text-red-500 text-sm mt-1 block">{usernameError}</span>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Unique Id</label>
                      <input
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-gray-50 focus:ring-4 focus:ring-gray-100 transition-all duration-200 outline-none text-gray-600 cursor-not-allowed"
                        readOnly
                        value={uniqueId?.unique_id || ""}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
                      <div className="relative">
                        <input
                          className={`w-full px-4 py-3 rounded-xl border-2 ${passwordError ? 'border-red-500 focus:border-red-500 focus:ring-red-100' : 'border-gray-200 focus:border-blue-500 focus:ring-blue-100'} focus:ring-4 transition-all duration-200 outline-none text-gray-700 placeholder-gray-400 pr-12`}
                          type={!showPassword ? "password" : "text"}
                          id="password"
                          name="password"
                          placeholder="Enter password"
                          onChange={handleInputChange}
                          value={values.password}
                          onBlur={() => validatePassword(values.password)}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                        >
                          {!showPassword ? (
                            <AiOutlineEyeInvisible size={20} />
                          ) : (
                            <AiOutlineEye size={20} />
                          )}
                        </button>
                      </div>
                      {passwordError && (
                        <span className="text-red-500 text-sm mt-1 block">{passwordError}</span>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Pattern Lock</label>
                      {mounted && (
                        <div className="bg-grey rounded-xl p-4 border border-gray-200"
                          style={{
                            background: "gray"
                          }}>
                          <PatternLock
                            path={path}
                            width={280}
                            size={3}
                            disabled={disabled}
                            onChange={(newPath) => {
                              if (Array.isArray(newPath)) {
                                setPath(newPath);
                              }
                            }}
                            onFinish={handlePatternFinish}
                            className="mx-auto"
                          />
                        </div>
                      )}
                      {patternError && (
                        <span className="text-red-500 font-medium text-sm mt-2 block">{patternError}</span>
                      )}
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
                      <input
                        className={`w-full px-4 py-3 rounded-xl border-2 ${emailError ? 'border-red-500 focus:border-red-500 focus:ring-red-100' : 'border-gray-200 focus:border-blue-500 focus:ring-blue-100'} focus:ring-4 transition-all duration-200 outline-none text-gray-700 placeholder-gray-400`}
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter email address"
                        onChange={handleInputChange}
                        value={values.email}
                        onBlur={() => validateEmail(values.email)}
                      />
                      {emailError && (
                        <span className="text-red-500 text-sm mt-1 block">{emailError}</span>
                      )}
                    </div>

                    {values.password ? (
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Confirm Password</label>
                        <div className="relative">
                          <input
                            className={`w-full px-4 py-3 rounded-xl border-2 ${confirmPasswordError ? 'border-red-500 focus:border-red-500 focus:ring-red-100' : 'border-gray-200 focus:border-blue-500 focus:ring-blue-100'} focus:ring-4 transition-all duration-200 outline-none text-gray-700 placeholder-gray-400 pr-12`}
                            type={!showConfirmPassword ? "password" : "text"}
                            name="confirmPassword"
                            id="confirmPassword"
                            placeholder="Confirm password"
                            onChange={handleInputChange}
                            value={values.confirmPassword}
                            onBlur={() => validateConfirmPassword(values.confirmPassword, values.password)}
                          />
                          <button
                            type="button"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                          >
                            {!showConfirmPassword ? (
                              <AiOutlineEyeInvisible size={20} />
                            ) : (
                              <AiOutlineEye size={20} />
                            )}
                          </button>
                        </div>
                        {confirmPasswordError && (
                          <span className="text-red-500 text-sm mt-1 block">{confirmPasswordError}</span>
                        )}
                      </div>
                    ) : null}

                    {values.password ? (
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Confirm Pattern</label>
                        {mounted && (
                          <div className="bg-grey rounded-xl p-4 border border-gray-200"
                          style={{
                            background: "gray"
                          }}>
                            <PatternLock
                              path={confirmPath}
                              width={280}
                              size={3}
                              disabled={confirmDisabled}
                              onChange={(newPath) => {
                                if (Array.isArray(newPath)) {
                                  setConfirmPath(newPath);
                                }
                              }}
                              onFinish={handleConfirmPatternFinish}
                              className="mx-auto"
                            />
                          </div>
                        )}
                        {confirmPatternError && (
                          <span className="text-red-500 font-medium text-sm mt-2 block">{confirmPatternError}</span>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            {/* Permissions Card */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 mb-6">
              <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-purple-50">
                <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                  <FaShieldAlt className="text-blue-600" />
                  Permissions
                </h2>
              </div>
              <div className="p-6">
                <PermissionsForm permissions={permissions} setPermissions={setPermissions} />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-end">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 hover:border-gray-300 transition-all duration-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              >
                <FaSave className="text-sm" />
                <span>Create Subadmin</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddSubAdmin;
